enum GridColumnAggregateEnum {
  SUM = 'sum',
  AVERAGE = 'average',
  MAX = 'max',
  MIN = 'min',
}

export { GridColumnAggregateEnum };
